import { render } from "./EditInterviewAttachment.vue?vue&type=template&id=f696b5e2"
import script from "./EditInterviewAttachment.vue?vue&type=script&lang=js"
export * from "./EditInterviewAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__